<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원관리</span>
            <span class="txt">
                센터에 등록한 회원님을 검색하실 수 있으며, 회원님의 성함을 눌러 이용권 등록 및 마일리지 등록 등 회원님의
                다양한 설정을 진행하실 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div style="display: flex; gap: 28px">
                <div class="photo-info-card">
                    <img
                        class="photo"
                        :src="customerInfo.imageUrl === null ? '/img/icons/no_photo.jpg' : customerInfo.imageUrl"
                        alt="사진"
                    />
                    <div class="info-txt">
                        <span class="txt name">{{ customerInfo.name + ` (${customerInfo.attendNo})` }}</span>
                        <span class="txt">{{ customerInfo.phone | phoneNumberFilter }}</span>
                        <span class="txt">{{ convertTeamGroupsToString(customerInfo.centerCustomerTeamGroups) }}</span>
                        <span class="txt">-</span>
                    </div>
                    <span v-if="customerInfo.status === 'V'" class="icon green">유효</span>
                    <span v-if="customerInfo.status === 'E'" class="icon red">만료</span>
                    <span v-if="customerInfo.status === '-'" class="icon gray">잠재</span>
                    <span v-if="customerInfo.status === 'H'" class="icon yellow">홀딩</span>
                    <!--<button class="send-btn">인증코드전송</button>-->
                </div>
                <div class="d-flex flex-column" style="margin-top: 35px">
                    <button
                        v-if="hasMessageEvent && customerInfo.mktAgreeSms"
                        class="com-btn white"
                        @click="routing('messageSend', customerInfo)"
                    >
                        메시지 발송
                    </button>
                    <button
                        v-show="isAllowed('ME', 6)"
                        class="com-btn white"
                        style="margin-top: 10px"
                        @click="showContractSendPopup()"
                    >
                        계약서 발송
                    </button>
                </div>
                <div class="info-card">
                    <div class="info-txt">
                        <span class="txt name">최근 수업일</span>
                        <span class="txt">{{ lastLessonDaysAgo }}일전</span>
                        <span class="txt">마지막 출석: {{ customerInfo.latestLessonAt | dateFormatFilter }}</span>
                    </div>
                </div>
            </div>
            <div class="com-tab">
                <button @click="onClickRouter('/madmin/member/info')">기본정보</button>
                <button @click="onClickRouter('/madmin/member/payment')">결제내역</button>
                <button @click="onClickRouter('/madmin/member/cancel')">예약/취소내역</button>
                <button @click="onClickRouter('/madmin/member/attend')">입장/출결내역</button>
                <button class="on">마일리지</button>
                <button
                    @click="
                        checkAllowedClick('MB', 3, () => {
                            onClickRouter('/madmin/member/advice');
                        })
                    "
                >
                    상담내역
                </button>
                <button @click="onClickRouter('/madmin/member/message')">메시지발송내역</button>
                <button v-show='isAllowed("ME", 7)' @click="onClickRouter('/madmin/member/contract_send')">계약서발송내역</button>
            </div>

            <div class="com-search-content">
                <div class="line">
                    <div class="com-calendar-wrap">
                        <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                        <div class="com-dash"><span class="dash">~</span></div>
                        <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                    </div>
                    <select-form
                        :select-data="['선택', ...periodTypeList]"
                        :select-value="['', ...periodTypeValueList]"
                        :selected-value="searchPeriod"
                        @update:set="(val) => (searchPeriod = val)"
                    ></select-form>
                </div>
                <div class="line">
                    <select-form
                        :select-data="['적립구분', '적립', '차감']"
                        :select-value="['', 'P', 'M']"
                        :selected-value="searchMileageType"
                        @update:set="(val) => (searchMileageType = val)"
                    ></select-form>
                    <button class="com-search-reset" @click="resetSearchContent"></button>
                </div>
            </div>

            <div class="com-table-content">
                <div class="com-btn-area">
                    <div class="left-box">
                        <span class="tit">
                            보유한 마일리지 : {{ String(customerInfo.mileage) | numberFormatFilter }}원
                        </span>
                        <!-- <span class="sub-tit red">당월 소멸예정 : {{ expireMileage }}원</span> -->
                    </div>
                    <div class="right-box">
                        <a
                            class="com-btn blue"
                            href="#"
                            @click="
                                checkAllowedClick('MB', 2, () => {
                                    mileagePop = true;
                                })
                            "
                        >
                            등록
                        </a>
                    </div>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 605px" />
                        <col style="width: 270px" />
                        <col style="width: 200px" />
                        <col style="width: 350px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>적립 내역</th>
                            <th>
                                <button @click="onClickMileageColumn">마일리지</button>
                            </th>
                            <th>
                                <button @click="onClickMileageTypeColumn">적립구분</button>
                            </th>
                            <th>
                                <button @click="onClickCreDtColumn">일자</button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(m, index) in mileageList" :key="index">
                            <td>{{ m.c_memo }}</td>
                            <td>
                                {{
                                    m.c_mileage_type_cd === 'P' ? m.c_mileage : (-1 * m.c_mileage) | numberFormatFilter
                                }}
                            </td>
                            <td>{{ m.c_mileage_type_cd === 'P' ? '적립' : '차감' }}</td>
                            <td>{{ m.c_cre_dt | timestampFilter2 }}</td>
                        </tr>
                        <tr v-if="mileageList.length === 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="sort-bottom-area">
                    <select-form
                        :select-data="[...sortTypeList]"
                        :select-value="[...sortTypeValueList]"
                        class="float-right"
                        @update:set="changeLimit"
                    ></select-form>
                </div>
                <b-pagination
                    v-model="mileagePagingInfo.page"
                    :per-page="mileagePagingInfo.limit"
                    :total-rows="mileagePagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event)"
                ></b-pagination>
            </div>

            <!-- 마일리지 등록 팝업 -->
            <div v-show="mileagePop" class="layer-pop square-type">
                <div class="view-content">
                    <button class="close" @click="mileagePop = false"><span class="blind">팝업 닫기</span></button>
                    <div class="scroll-area com-scroll-y">
                        <span class="sub-title">마일리지 등록</span>
                        <p class="sub-txt">마일리지를 수기로 적립 또는 차감이 가능합니다.</p>
                        <ul class="form-list">
                            <li>
                                <span class="tit">회원명 :</span>
                                <span class="name">{{ customerInfo.name }}</span>
                            </li>
                            <li>
                                <span class="tit">결제수단 :</span>
                                <div class="com-radio">
                                    <input
                                        id="radio-pop-1"
                                        v-model="editField.mileageType"
                                        name="radio-pop"
                                        type="radio"
                                        value="P"
                                    />
                                    <label for="radio-pop-1">적립</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-pop-2"
                                        v-model="editField.mileageType"
                                        name="radio-pop"
                                        type="radio"
                                        value="M"
                                    />
                                    <label for="radio-pop-2">차감</label>
                                </div>
                            </li>
                            <li>
                                <span class="tit">
                                    <span class="imp">*</span>
                                    금액 :
                                </span>
                                <input
                                    v-model="editField.mileage"
                                    maxlength="8"
                                    type="text"
                                    @keypress="isNumber(editField.mileage)"
                                    @keyup="onKeyUpAcmltMileage"
                                />
                                <span class="txt">원</span>
                            </li>
                            <li>
                                <span class="tit">
                                    <span class="imp">*</span>
                                    내용 :
                                </span>
                                <input v-model="editField.memo" class="w435" maxlength="20" type="text" />
                            </li>
                        </ul>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="onClickCancleMileage">취소</button>
                            <button class="com-btn blue" @click="onClickRegistMileage">등록</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <contract-send-dlg
            v-if="contractSendPop"
            :show="contractSendPop"
            :info="contractSendInfo"
            :close="handleCloseContractSend"
            :charge="handleCharge"
            :paymentLinkSend="handlePaymentLinkSend"
        ></contract-send-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '@/assets/js/eventBus';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';
import { Utils } from '@/assets/js/utils';
export default {
    name: 'memberMileage',
    mixins: [MixinAllowedMenu],
    props: {},
    computed: {
        Utils() {
            return Utils;
        },

        lastLessonDaysAgo() {
            if (this.customerInfo.latestLessonAt) {
                return moment().startOf('day').diff(moment(this.customerInfo.latestLessonAt).startOf('day'), 'days');
            }

            return '-';
        }
    },
    watch: {
        searchPeriod: function (newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.fetchCustomerMileage();
        },
        startDate: function (newValue) {
            // 검색 시작일
            this.startDate = newValue;
        },
        endDate: function (newValue) {
            // 검색 종료일
            this.endDate = newValue;
        },
        searchMileageType: function (newValue) {
            // 적립 구분
            this.searchMileageType = newValue;
            this.fetchCustomerMileage();
        },
    },
    mounted() {
        this.init();
    },
    data() {
        return {
            hasMessageEvent: false, // 메시지 계약되었을시..

            mileagePop: false,
            isLoading: false,
            centerId: this.$route.params.id,
            customerId: this.$route.query.customerId,
            customerInfo: {}, // 회원 정보
            mileageList: [], // 회원 마일리지 목록
            editField: {
                mileageType: 'P',
                mileage: '',
                memo: '',
            },
            mileagePagingInfo: { ...pagingInfo },

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],

            searchSortType: '', // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
            startDate: '', // 검색시작일자
            endDate: '', // 검색종료일자
            searchMileageType: '', // 적립/차감 구분코드 (적립:P, 차감:M)
            searchSortColumn: '', // 정렬컬럼 (마일리지 : mileage, 적립구분 : mileageType, 등록일 : createDate)
            searchPeriod: '', // 검색 기간 설정

            expireMileage: 0,

            contractSendPop: false,
            contractSendInfo: {},
            centerInfo: {},
        };
    },
    methods: {
        onKeyUpAcmltMileage() {
            // 적립 마일리지 업데이트
            const num = Utils.getPureNumber(this.editField.mileage);
            this.editField.mileage = num;
            this.editField.mileage = Utils.getNumberFormat(num);
            // this.onChange();
        },
        routing(toName, checkedUserData) {
            const routingData = [];
            console.log(checkedUserData);
            // checkedUserData.forEach((param) => {
            const tempValue = {
                ...checkedUserData,
            };
            routingData.push(tempValue);
            // });
            this.$router.push({
                name: toName,
                params: { data: routingData },
            });
        },

        checkMessageEvent() {
            return api
                .get('/admin/api/center/ftcontract/sms')
                .then((res) => {
                    this.hasMessageEvent = JSON.parse(res.data);
                })
                .catch((error) => {
                    this.hasMessageEvent = false;
                });
        },

        // 초기화
        async init() {
            this.isLoading = true;
            await this.fetchCustomerDetail(); // 회원 정보 가져오기
            await this.fetchCustomerMileage(); // 회원 마일리지 목록 가져오기
            // await this.fetchCustomerExpireMileage(); // 소멸 예정 마일리지 가져오기
            this.initStartDate();
            this.initEndDate();
            await this.checkMessageEvent();
            this.getCenterInfo(); // 로그인한 센터 정보 가져오기
            this.isLoading = false;
        },
        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        // 회원 정보 가져오기
        async fetchCustomerDetail() {
            try {
                const { data } = await this.sendGetCustomerDetail();
                this.customerInfo = data;
                this.customerInfo.centerCustomerTeamGroups = this.customerInfo.centerCustomerTeamGroups.filter(
                    (g) => !g.centerCustomerTeam.info.deleteYn
                );
            } catch (error) {
                alert('회원정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 회원 기본정보 조회 API 호출
        sendGetCustomerDetail() {
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}`);
        },

        // 회원 마일리지 목록 가져오기
        async fetchCustomerMileage() {
            try {
                const { data } = await this.sendGetCustomerMileage();
                this.setPageParams(data);
                this.mileageList = data.items;
            } catch (error) {
                alert('마일리지 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 회원 마일리지 목록 조회 API 호출
        sendGetCustomerMileage() {
            let { startDate, endDate, searchMileageType, searchSortColumn, searchSortType } = this;
            let searchParams = {
                sortType: searchSortType, // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
                startDate, // 검색시작일자
                endDate, // 검색종료일자
                mileageType: searchMileageType, // 적립/차감 구분코드 (적립:P, 차감:M)
                sortColumn: searchSortColumn, // 정렬컬럼 (마일리지 : mileage, 적립구분 : mileageType, 등록일 : createDate)
            };
            // 스웨거 검색: 센터회원 마일리지 페이징 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}/mileage`, {
                params: {
                    ...this.mileagePagingInfo,
                    ...searchParams,
                },
            });
        },

        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}/${this.centerId}`, query: { customerId: this.customerId } });
        },

        // 마일리지 등록 버튼 클릭시
        async onClickRegistMileage() {
            try {
                const { data } = await this.sendPostRegistMileage();
                alert('마일리지가 등록 되었습니다.');
                this.onClickCancleMileage(); // 등록 후 팝업 감추고 변수 초기화
                await this.fetchCustomerDetail();
                this.fetchCustomerMileage();
            } catch (error) {
                alert('마일리지 적립 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 마일리지 등록 API 호출
        sendPostRegistMileage() {
            let params = this.getRegistParams();
            return api.post(`/admin/api/center/${this.centerId}/customer/${this.customerId}/mileage`, {
                ...params,
            });
        },

        // 마일리지 등록 파라미터 가공
        getRegistParams() {
            const { editField } = this;
            editField.mileage = Utils.getPureNumber(editField.mileage);
            let params = {
                manualYn: true, // 수기 등록 여부
                ...editField,
            };
            return params;
        },

        // 마일리지 등록 팝업 취소 버튼 클릭시
        onClickCancleMileage() {
            this.mileagePop = false;
            this.editField = {
                // 마일리지 등록 관련 변수 초기화
                mileageType: 'P',
                mileage: '',
                memo: '',
            };
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.mileagePagingInfo.limit = val;
            this.fetchCustomerMileage();
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.mileagePagingInfo.page = event;
            this.fetchCustomerMileage();
        },

        // 페이징 Param set
        setPageParams(data) {
            this.mileagePagingInfo.totalPages = data.meta.totalPages;
            this.mileagePagingInfo.page = data.meta.currentPage;
            this.mileagePagingInfo.totalItems = data.meta.totalItems;
            this.mileagePagingInfo.itemCount = data.meta.itemCount;
        },

        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.fetchCustomerMileage();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.fetchCustomerMileage();
        },

        // 검색 조건 초기화
        resetSearchContent() {
            this.initStartDate();
            this.initEndDate();
            this.searchPeriod = '';
            this.searchSortType = '';
            this.searchMileageType = '';
            this.searchSortColumn = '';
            this.fetchCustomerMileage();
            EventBus.$emit('event:init', 'init');
        },

        // 마일리지 컬럼 클릭시
        onClickMileageColumn() {
            this.searchSortColumn = 'mileage';
            if (this.searchSortType === '' || this.searchSortType === 'DESC') {
                this.searchSortType = 'ASC';
            } else {
                this.searchSortType = 'DESC';
            }
            this.fetchCustomerMileage();
        },

        // 적립구분 컬럼 클릭시
        onClickMileageTypeColumn() {
            this.searchSortColumn = 'mileageType';
            if (this.searchSortType === '' || this.searchSortType === 'DESC') {
                this.searchSortType = 'ASC';
            } else {
                this.searchSortType = 'DESC';
            }
            this.fetchCustomerMileage();
        },

        // 일자 컬럼 클릭시
        onClickCreDtColumn() {
            this.searchSortColumn = 'createDate';
            if (this.searchSortType === '' || this.searchSortType === 'DESC') {
                this.searchSortType = 'ASC';
            } else {
                this.searchSortType = 'DESC';
            }
            this.fetchCustomerMileage();
        },

        // 숫자 이외의 입력 방지
        isNumber(evt) {
            return (this.editField.mileage = Utils.getNumberFormat(Utils.getPureNumber(evt)));
        },

        // 회원 정보 카드에 나타낼 회원 그룹 이름 만들기
        convertTeamGroupsToString(teamGroups) {
            if (teamGroups === undefined) {
                return;
            }
            if (teamGroups.length === 1) {
                // 그룹이 1개일 경우
                return teamGroups[0].centerCustomerTeamName;
            } else if (teamGroups.length === 0) {
                // 그룹이 없을 경우
                return '-';
            } else if (teamGroups.length > 1) {
                // 그룹이 여러개일 경우
                return teamGroups[0].centerCustomerTeamName + ' 외 ' + (teamGroups.length - 1);
            }
        },

        // 소멸 예정 마일리지 가져오기
        async fetchCustomerExpireMileage() {
            try {
                const { data } = await this.sendGetCustomerExpireMileage();
                if (data.expireMileage === null) {
                    this.expireMileage = 0;
                } else {
                    this.expireMileage = data.expireMileage;
                }
            } catch (error) {
                console.log(error);
            }
        },

        // 센터회원 소멸예정 마일리지 조회
        sendGetCustomerExpireMileage() {
            const month = moment().format('YYYYMM');
            return api.get(
                `/admin/api/center/${this.centerId}/customer/${this.customerId}/mileage/expireMileage/${month}`
            );
        },

        handleCloseContractSend() {
            this.contractSendPop = false;
        },

        handleCharge() {
            this.contractSendPop = false;
        },

        handlePaymentLinkSend() {
            this.contractSendPop = false;

            this.onClickRouter('/madmin/member/contract_send');
        },

        showContractSendPopup() {
            this.contractSendInfo = {
                centerId: this.centerId,
                centerName: this.centerInfo.centerName,
                customerId: this.customerId,
                customerName: this.customerInfo.name,
                customerPhone: this.customerInfo.phone,
                templateType: 'M',
            };
            this.contractSendPop = true;
        },
    },
};
</script>
<style lang="scss"></style>
